module.exports = __webpack_public_path__ + "img/inventory_optimization.33d4e876.svg";